import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { generateEnhancedShareUrl } from '../../masonry-utils';
import ShareBtn from './ShareBtn';

class LinkedinShareBtn extends ShareBtn {
  static get properties() {
    return {
      ...super.properties,
      post: { type: Object },
    };
  }

  constructor() {
    super();
    this.icon = faLinkedin;
    this.color = '#2867B2';
  }

  /**
   * Gets the LinkedIn share URL with enhanced URL tracking
   * @returns {string} LinkedIn share URL
   */
  get shareURL() {
    const url = this.post ? generateEnhancedShareUrl(this.post) : window.location.href;
    return `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(url)}`;
  }
}

export default LinkedinShareBtn;
